export default __webpack_public_path__ + "static/media/NeonLight-Regular.9b972396.otf";